import { Navigate, useSearchParams } from 'react-router-dom';
import { resolveSettingsPath, resolveLegacyClubSettingsPath } from '@/lib/settingsTabRoutes';

export function LegacyOrgSettingsRedirect() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  return <Navigate to={resolveSettingsPath(tab)} replace />;
}

export function LegacyAcademySettingsRedirect() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  return <Navigate to={resolveSettingsPath(tab)} replace />;
}

/** @deprecated Old monolith path — redirects to the correct settings surface by tab. */
export function LegacyClubSettingsRedirect() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  return <Navigate to={resolveLegacyClubSettingsPath(tab)} replace />;
}
